import React, { useState, useEffect, useRef } from "react";
import "./Admin.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FaUserCircle } from "react-icons/fa";
import ConfirmationModal from "../../../../Component/CompanyAdmin/CompanyAdminHome/ConfirmModel";
import claimproassist from "../../../../Assets/claimproassistwithoutName.jpg";
import MenuIcon from "@mui/icons-material/Menu";
import { Helmet } from "react-helmet-async";
import StoreIcon from "@mui/icons-material/Store";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import BadgeIcon from "@mui/icons-material/Badge";
import SpaceDashboardIcon from "@mui/icons-material/SpaceDashboard";
import ReportIcon from "@mui/icons-material/Report";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import HailIcon from "@mui/icons-material/Hail";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import SensorOccupiedIcon from "@mui/icons-material/SensorOccupied";
import CenterFocusWeakIcon from "@mui/icons-material/OpenWith";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import userImg from "../../../../Assets/userImg.jpg";
import logo from "../../../../Assets/navbar/logo.svg";

const NAV_ITEMS = [
  {
    id: "dashboard",
    label: "Dashboard",
    route: "/admin-dashboard-vendor-customer",
    icon: <SpaceDashboardIcon style={{ fontSize: 16 }} />,
  },
  {
    id: "vendor",
    label: "Vendor",
    icon: <StoreIcon style={{ fontSize: 16 }} />,
    children: [
      { label: "Add Vendor",  route: "/vendor-form" },
      { label: "View Vendor", route: "/vendor-view-form" },
      { label: "Sign-up",     route: "/NewVendorApproved" },
    ],
  },
  {
    id: "customer",
    label: "Customer",
    icon: <PersonOutlineIcon style={{ fontSize: 16 }} />,
    children: [
      { label: "Add Customer",               route: "/customer-form" },
      { label: "View Customer",              route: "/customer-view-form" },
      { label: "Vehicle Inspection Reports", route: "/admin-inspection-reports" },
    ],
  },
  {
    id: "employee",
    label: "Employee",
    icon: <BadgeIcon style={{ fontSize: 16 }} />,
    children: [
      { label: "Add Employee",  route: "/employee-form" },
      { label: "View Employee", route: "/view-employee" },
    ],
  },
  {
    id: "vehicle",
    label: "Vehicle Reported",
    icon: <ReportIcon style={{ fontSize: 16 }} />,
    children: [
      { label: "Initial Reg",   route: "/signup-form-view" },
      { label: "Register",      route: "/accident-vehicle-register-update" },
      { label: "View Register", route: "/view-accident-vehicle-register-details" },
      { label: "Registered Vehicles", 
        route: "/view-registered-vehicles" },
    ],
  },
  {
    id: "workshop",
    label: "Workshop Dashboard",
    route: "/admin/workshop-dashboard",
    icon: <StoreIcon style={{ fontSize: 16 }} />,
  },
  {
    id: "assigned",
    label: "Assigned Vehicle",
    icon: <LocalShippingIcon style={{ fontSize: 16 }} />,
    children: [
      { label: "Vendors",  route: "/accident-vehicle" },
      { label: "Response", route: "/vendor-response" },
    ],
  },
  {
    id: "other",
    label: "Other Forms",
    icon: <HailIcon style={{ fontSize: 16 }} />,
    children: [
      { label: "Visitor Form",       route: "/Visitors-form" },
      { label: "Customer Enquiry",   route: "/customer-enquiry-form" },
      { label: "Challan",            route: "/challan-form" },
      { label: "General Inspection", route: "/general-inspection" },
      { label: "Fleet Dashboard",    route: "/fleet-dashboard" },
      { label: "Fleet List",         route: "/fleet-list" },
      { label: "FASTag",            route: "/fastag-details" },
      { label: "FASTag Dashboard",            route: "/fastag-dashboard" },
    ],
  },
  {
    id: "surveyor",
    label: "Surveyor",
    icon: <HailIcon style={{ fontSize: 16 }} />,
    children: [
      { label: "Add Surveyor",  route: "/add-surveyor" },
      { label: "View Surveyor", route: "/view-surveyor" },
    ],
  },
];

// Keep the full menu visible and enforce access in the click handler.
const getFilteredNavItems = () => NAV_ITEMS;

const Admin = () => {
  const [showUserId, setShowUserId] = useState(false);
  const [userImage, setUserImage] = useState(true);
  const [unauthorizedMessage, setUnauthorizedMessage] = useState("");

  const [getData, setGetData] = useState({});
  const [highlightData, setHighlightData] = useState(false);

  // Stats state
  const [activeCases, setActiveCases] = useState(null);
  const [pendingCases, setPendingCases] = useState(null);
  const [unreadNotifications, setUnreadNotifications] = useState(0);

  let navigate = useNavigate();

  const userDropdownRef = useRef(null);
  const [isModalOpen, setModalOpen] = useState(false);

  const resetStates = () => {
  };

  const vendorData = [10, 5, 15, 20];
  const vendorLabels = ["Advocate", "Crane", "Mechanic", "Workshops"];

  const customerData = [30, 70];
  const customerLabels = ["Bulk Customers", "Single Customers"];

  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");
  const loginId = localStorage.getItem("loginId");
  const [refreshToken, setRefreshToken] = useState(
    localStorage.getItem("token"),
  );
  const [refreshUserId, setRefreshUserId] = useState(
    localStorage.getItem("userId"),
  );
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const sidebarRef = useRef(null);
  const [notificationSent, setNotificationSent] = useState(false);

  const [openDropdown,   setOpenDropdown]   = useState(null);
  const [activeItem,     setActiveItem]     = useState("dashboard");
  const [mobileNavOpen,  setMobileNavOpen]  = useState(false);
  const [mobileExpanded, setMobileExpanded] = useState(null);
  const [dropdownPos,    setDropdownPos]    = useState({ top: 0, left: 0 });

  const navBarRef        = useRef(null);
  const dropdownPanelRef = useRef(null);

  const handleSignOutClick = () => {
    setModalOpen(true);
  };

  const handleConfirmSignOut = async () => {
    const response = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/api/logout/${userId}`,
      { userId },
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    if (response.status === 200) {
      localStorage.setItem("token", "");
      localStorage.setItem("userId", "");
      localStorage.setItem("loginId", "");
      localStorage.setItem("department", "");
      setRefreshToken("");
      setRefreshUserId("");
      setModalOpen(false);
      navigate("/loginPage");
    } else {
      setModalOpen(true);
    }
  };

  const handleCancelSignOut = () => {
    setModalOpen(false);
  };

  const tokenRef = useRef(null);
  const [lastMessageId, setLastMessageId] = useState(null);

  const getCurrentTime = () => {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");
    const milliseconds = String(now.getMilliseconds()).padStart(3, "0");
    return `${hours}:${minutes}:${seconds}:${milliseconds}`;
  };

  const handleSearchClick = () => {
    setTimeout(() => setHighlightData(false), 2000);
  };


  const publicVapidKey =
    "BI0sWPKFjmxnkWYcwjylL7qmo9svTNzEyuEG8-xyswDkQ_FKbONR1yQ6CAUZ9EsryyJiQATfDUZnfloTn8z9DS0";
  const effectRan = useRef(false);
  const urlBase64ToUint8Array = (base64String) => {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding)
      .replace(/-/g, "+")
      .replace(/_/g, "/");
    const rawData = window.atob(base64);
    return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
  };

  const [isFirstCallComplete, setIsFirstCallComplete] = useState(false);
  const [notFoundPage, setNotFoundPage] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/rightPerson/${userId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );
        if (response.data.message === "right Person!!!") {
          setIsFirstCallComplete(true);
        } else {
          setNotFoundPage(true);
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };

    if (userId != "") fetchData();
  }, [userId, token]);

  useEffect(() => {
    if (isFirstCallComplete && effectRan.current === false) {
      const sendLoginNotification = async () => {
        try {
          const registration =
            await navigator.serviceWorker.register("/service-worker.js");

          const subscription = await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(publicVapidKey),
          });

          await axios.post(
            `${process.env.REACT_APP_BACKEND_URL}/api/subscription/${userId}`,
            subscription,
            { headers: { Authorization: `Bearer ${token}` } },
          );
          await axios.post(
            `${process.env.REACT_APP_BACKEND_URL}/api/notification`,
            { message: "You have logged in right now" },
          );
        } catch (error) {
          console.error("Error sending login notification:", error);
        }
      };

      sendLoginNotification();
      effectRan.current = true;
    }
  }, [isFirstCallComplete]);

  function showOfflineAlert() {
    const alertBox = document.createElement("div");
    alertBox.id = "offlineAlert";
    alertBox.innerText = "No internet connection. Please turn on WiFi.";
    alertBox.style.position = "fixed";
    alertBox.style.top = "10px";
    alertBox.style.left = "50%";
    alertBox.style.transform = "translateX(-50%)";
    alertBox.style.background = "red";
    alertBox.style.color = "white";
    alertBox.style.padding = "10px 20px";
    alertBox.style.borderRadius = "5px";
    alertBox.style.boxShadow = "0px 4px 6px rgba(0, 0, 0, 0.1)";
    alertBox.style.zIndex = "1000";
    document.body.appendChild(alertBox);
  }

  function removeOfflineAlert() {
    const alertBox = document.getElementById("offlineAlert");
    if (alertBox) {
      alertBox.remove();
    }
  }

  window.addEventListener("offline", showOfflineAlert);
  window.addEventListener("online", removeOfflineAlert);

  useEffect(() => {
    if (isFirstCallComplete) {
      const findUserById = async (userId) => {
        try {
          let response = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/api/findById/${userId}`,
            {
              headers: { Authorization: `Bearer ${token}` },
            },
          );
          if (response.data.message === "No user found") {
            response = await axios.get(
              `${process.env.REACT_APP_BACKEND_URL}/api/getEmployee/${userId}/${userId}`,
            );
          }
          setGetData(response.data.data[0]);
          localStorage.setItem("name", response.data.data[0]?.username || response.data.data[0]?.name || "");
        } catch (error) {
          console.log("error", error.message);
        }
      };
      if (userId != "") {
        findUserById(userId);
      }
    }
  }, [isFirstCallComplete, userId]);

  // Fetch dashboard stats for header pills
  useEffect(() => {
    if (!isFirstCallComplete) return;
    const fetchStats = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/dashboard-stats`,
          { headers: { Authorization: `Bearer ${token}` } },
        );
        if (response.data) {
          setActiveCases(response.data.activeCases ?? null);
          setPendingCases(response.data.pendingCases ?? null);
          setUnreadNotifications(response.data.unreadNotifications ?? 0);
        }
      } catch (error) {
        // Stats are non-critical — fail silently
      }
    };
    fetchStats();
  }, [isFirstCallComplete]);

  function toggleSidebar() {
    setIsSidebarOpen(!isSidebarOpen);
  }

  const getStyle = (startingPage) => {
    if (startingPage) {
      return {
        paddingLeft: "0px",
        marginLeft: "0px",
        backgroundColor: "#1a0c0c",
      };
    } else {
      return { paddingLeft: "0px", marginLeft: "0px" };
    }
  };

  const handleClickOutside = (event) => {
    if (userDropdownRef.current && !userDropdownRef.current.contains(event.target)) {
      setShowUserId(false);
    }
    if (
      window.innerWidth < 768 &&
      sidebarRef.current &&
      !sidebarRef.current.contains(event.target)
    ) {
      setIsSidebarOpen(false);
    }
  };

  useEffect(() => {
    if (showUserId || isSidebarOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showUserId, isSidebarOpen]);

  const handleFullScreenToggle = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
    } else if (document.exitFullscreen) {
      document.exitFullscreen();
    }
  };

  const showDashboard = () => {
    resetStates();
  };

  useEffect(() => {
    const handleNavOutsideClick = (e) => {
      const inNavBar = navBarRef.current      && navBarRef.current.contains(e.target);
      const inPanel  = dropdownPanelRef.current && dropdownPanelRef.current.contains(e.target);
      if (!inNavBar && !inPanel) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener("mousedown", handleNavOutsideClick);
    return () => document.removeEventListener("mousedown", handleNavOutsideClick);
  }, []);

  // Route protection for HR and Operations users
  useEffect(() => {
    const department = localStorage.getItem("department");
    const currentPath = window.location.pathname;
    const restrictedRoutes = ["/employee-form", "/view-employee"];

    const isRestricted =
    department?.toLowerCase() === "operations" ||
    department?.toLowerCase() === "kam";  

    if (isRestricted && restrictedRoutes.includes(currentPath)) {
    setUnauthorizedMessage("You are not authorized to access this page");
    navigate("/admin-dashboard-vendor-customer", { replace: true });
    setTimeout(() => setUnauthorizedMessage(""), 3000);
  }
  }, [navigate]);

  const go = (route, itemId) => {
    const department = localStorage.getItem("department");
    const allowedHRRoutes = ["/admin-dashboard-vendor-customer", "/employee-form", "/view-employee"];
    const restrictedOperationsRoutes = ["/employee-form", "/view-employee"];
    const restrictedKAMRoutes = ["/employee-form", "/view-employee"];
    
    // Prevent HR users from navigating to unauthorized routes
    if (department?.toLowerCase() === "hr" && !allowedHRRoutes.includes(route)) {
      setUnauthorizedMessage("You are not authorized to access this page");
      console.warn("HR users can only access Employee routes");
      // Clear message after 3 seconds
      setTimeout(() => setUnauthorizedMessage(""), 3000);
      return;
    }
    
    // Prevent Operations users from navigating to restricted employee routes
    if (department?.toLowerCase() === "operations" && restrictedOperationsRoutes.includes(route)) {
      setUnauthorizedMessage("You are not authorized to access this page");
      console.warn("Operations users cannot access Employee routes");
      // Clear message after 3 seconds
      setTimeout(() => setUnauthorizedMessage(""), 3000);
      return;
    }

      if (department?.toLowerCase() === "kam" && restrictedKAMRoutes.includes(route)) {
      setUnauthorizedMessage("You are not authorized to access this page");
      setTimeout(() => setUnauthorizedMessage(""), 3000);
      return;
    }
    
    setActiveItem(itemId);
    setOpenDropdown(null);
    setMobileNavOpen(false);
    navigate(route);
  };

  const toggleDropdown = (id, e) => {
    if (openDropdown === id) {
      setOpenDropdown(null);
    } else {
      const rect = e.currentTarget.getBoundingClientRect();
      setDropdownPos({ top: rect.bottom, left: rect.left });
      setOpenDropdown(id);
    }
  };

  const userName = getData?.username || getData?.name || "Admin";
  const userRole = localStorage.getItem("department") || "Admin";

  return (
    <div>
      <div
        className="font-satoshi text-[#21A6E9] admin-page"
        style={{ height: "70px" }}
      >
        <Helmet>
          <title>Admin Page - Claimpro</title>
          <meta name="description" content="Admin Page." />
          <meta
            name="keywords"
            content="Vehicle Accidents, accident trucks,  Customer Service, Claimpro, Claim pro Assist, Claimpro Assist ,Accidental repair ,Motor Insurance claim,Advocate services ,Crane service ,On site repair,Accident Management"
          />
          <link rel="canonical" href={`https://claimpro.in/Admin`} />
        </Helmet>

        {/* ── UNAUTHORIZED MESSAGE ── */}
        {unauthorizedMessage && (
          <div style={{
            position: "fixed", top: 60, left: "50%", transform: "translateX(-50%)",
            background: "#fee2e2", border: "1px solid #fecaca",
            color: "#dc2626", padding: "12px 20px",
            borderRadius: 6, fontSize: 14, fontWeight: 500,
            zIndex: 1300, animation: "slideDown 0.3s ease-out",
            boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
          }}>
            {unauthorizedMessage}
          </div>
        )}
        <style>{`
          @keyframes slideDown {
            from { opacity: 0; transform: translateX(-50%) translateY(-10px); }
            to { opacity: 1; transform: translateX(-50%) translateY(0); }
          }
        `}</style>

        {/* ── TOP BAR ── */}
        <div style={{
          position: "fixed", top: 0, left: 0, right: 0, height: 52,
          background: "#ffffff",
          borderBottom: "1.5px solid #e2e8f0",
          display: "flex", alignItems: "center", justifyContent: "space-between",
          padding: "0 20px", zIndex: 1001,
          gap: 12,
        }}>
          {/* Logo + Brand */}
          <div style={{ display: "flex", alignItems: "center", gap: 18, flexShrink: 0, cursor: "pointer" }}
            onClick={() => {
              const dept = localStorage.getItem("department");
              if (dept?.toLowerCase() === "hr") {
                navigate("/view-employee", { replace: true });
              } else {
                go("/admin-dashboard-vendor-customer", "dashboard");
              }
            }}
          >
            <img
              src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/logo-navbar-compressed.png"
              alt="ClaimPro Assist"
              style={{ height: 52, width: "auto", objectFit: "contain" }}
            />
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <span style={{
                fontSize: 17, fontWeight: 800, color: "#21A6E9",
                letterSpacing: 0.3, whiteSpace: "nowrap",
              }}>
                ClaimPro<span style={{ color: "#21A6E9" }}> Assist</span>
              </span>
              <div style={{ width: 1.5, height: 18, background: "#94a3b8", flexShrink: 0 }} />
              <span style={{
                fontSize: 12.5, fontWeight: 600, color: "#475569", fontStyle: "italic",
                letterSpacing: 0.4, whiteSpace: "nowrap",
              }}>
                दुर्घटना सें... समाधान तक
              </span>
            </div>
          </div>

          {/* Right side controls */}
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>

            {/* Stat pills — only render when data is available */}
            {activeCases !== null && (
              <div style={{
                display: "flex", alignItems: "center", gap: 6,
                padding: "4px 12px",
                background: "#f0fdf4",
                border: "1px solid #bbf7d0",
                borderRadius: 20,
                flexShrink: 0,
              }}>
                <div style={{ width: 7, height: 7, borderRadius: "50%", background: "#22c55e" }} />
                <span style={{ fontSize: 12, fontWeight: 600, color: "#15803d" }}>{activeCases}</span>
                <span style={{ fontSize: 11, color: "#16a34a" }}>Active</span>
              </div>
            )}
            {pendingCases !== null && (
              <div style={{
                display: "flex", alignItems: "center", gap: 6,
                padding: "4px 12px",
                background: "#fffbeb",
                border: "1px solid #fde68a",
                borderRadius: 20,
                flexShrink: 0,
              }}>
                <div style={{ width: 7, height: 7, borderRadius: "50%", background: "#f59e0b" }} />
                <span style={{ fontSize: 12, fontWeight: 600, color: "#b45309" }}>{pendingCases}</span>
                <span style={{ fontSize: 11, color: "#d97706" }}>Pending</span>
              </div>
            )}

            {/* Thin divider */}
            {(activeCases !== null || pendingCases !== null) && (
              <div style={{ width: 1, height: 20, background: "#e2e8f0", flexShrink: 0 }} />
            )}

            {/* Notification bell */}
            <div
              onClick={() => {/* open notifications panel */}}
              style={{
                width: 34, height: 34, borderRadius: 8,
                border: "1px solid #e2e8f0",
                background: "#f8fafc",
                display: "flex", alignItems: "center", justifyContent: "center",
                cursor: "pointer", position: "relative", flexShrink: 0,
              }}
              title="Notifications"
              onMouseEnter={(e) => e.currentTarget.style.background = "#f1f5f9"}
              onMouseLeave={(e) => e.currentTarget.style.background = "#f8fafc"}
            >
              <NotificationsNoneIcon style={{ fontSize: 18, color: "#64748b" }} />
              {unreadNotifications > 0 && (
                <div style={{
                  position: "absolute", top: 5, right: 5,
                  width: 8, height: 8, borderRadius: "50%",
                  background: "#ef4444",
                  border: "1.5px solid #ffffff",
                }} />
              )}
            </div>

            {/* Fullscreen — icon only */}
            <button
              onClick={handleFullScreenToggle}
              style={{
                width: 34, height: 34, borderRadius: 8,
                border: "1px solid #e2e8f0",
                background: "#f8fafc",
                display: "flex", alignItems: "center", justifyContent: "center",
                cursor: "pointer", flexShrink: 0,
              }}
              title="Toggle fullscreen"
              onMouseEnter={(e) => e.currentTarget.style.background = "#f1f5f9"}
              onMouseLeave={(e) => e.currentTarget.style.background = "#f8fafc"}
            >
              <CenterFocusWeakIcon style={{ fontSize: 16, color: "#64748b" }} />
            </button>

            {/* Thin divider */}
            <div style={{ width: 1, height: 20, background: "#e2e8f0", flexShrink: 0 }} />

            {/* Hamburger — mobile only */}
            <button
              id="cpa-hamburger"
              onClick={() => setMobileNavOpen(!mobileNavOpen)}
              style={{
                background: "none", border: "none", cursor: "pointer",
                display: "none",
                alignItems: "center", padding: 4,
              }}
            >
              <MenuIcon style={{ color: "#475569", fontSize: 22 }} />
            </button>

            {/* User info + avatar */}
            <div style={{ position: "relative" }} ref={userDropdownRef}>
              <div
                onClick={() => setShowUserId(!showUserId)}
                style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }}
              >
                {/* Name + role — hidden on small screens via inline media below */}
                <div id="cpa-user-meta" style={{ textAlign: "right" }}>
                  <div style={{ fontSize: 12, fontWeight: 600, color: "#1e293b", lineHeight: 1.2 }}>
                    {userName}
                  </div>
                  <div style={{ fontSize: 10, color: "#94a3b8", lineHeight: 1.2, textTransform: "capitalize" }}>
                    {userRole}
                  </div>
                </div>

                {userImage ? (
                  <img
                    src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/userImg.jpg"
                    alt="User"
                    style={{
                      width: 32, height: 32, borderRadius: "50%",
                      objectFit: "cover", border: "2px solid rgba(33,166,233,.4)",
                      flexShrink: 0,
                    }}
                  />
                ) : (
                  <div style={{
                    width: 32, height: 32, borderRadius: "50%",
                    background: "#21A6E9", display: "flex", alignItems: "center",
                    justifyContent: "center", color: "#fff", fontSize: 12, fontWeight: 600,
                    flexShrink: 0,
                  }}>
                    {userName.charAt(0).toUpperCase()}
                  </div>
                )}
              </div>

              {showUserId && (
                <div
                  className={`dropdown-container ${showUserId ? "show" : ""}`}
                  style={{
                    position: "absolute", top: "calc(100% + 10px)", right: 0,
                    zIndex: 1202,
                  }}
                >
                  <div style={{
                    marginBottom: "10px", fontSize: "16px",
                    fontWeight: "bold", color: "#333", marginTop: "15px",
                  }}>
                    User Information
                  </div>
                  <span style={{ fontSize: "14px", color: "#555", marginBottom: "10px" }}>
                    User Name: {getData.username || getData.name} <br />
                    User Id: {getData.randomId || getData.id}
                  </span>
                  <button
                    onClick={handleSignOutClick}
                    style={{
                      padding: "10px 20px", fontSize: "14px", color: "#fff",
                      backgroundColor: "#007bff", border: "none",
                      borderRadius: "5px", cursor: "pointer", outline: "none",
                      width: "100%", textAlign: "center", marginTop: "15px",
                    }}
                  >
                    Sign Out
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* ── NAV BAR ── */}
        <div
          ref={navBarRef}
          id="cpa-nav-bottom"
          style={{
            position: "fixed", top: 52, left: 0, right: 0, height: 44,
            background: "#ffffff",
            borderBottom: "1.5px solid #e2e8f0",
            display: "flex", alignItems: "stretch",
            padding: "0 12px", zIndex: 1000,
            overflowX: "auto", overflowY: "visible",
          }}
        >
          <style>{`
            #cpa-nav-bottom::-webkit-scrollbar { display: none; }
            #cpa-nav-bottom { -ms-overflow-style: none; scrollbar-width: none; }
            @media (max-width: 860px) {
              #cpa-nav-bottom  { display: none !important; }
              #cpa-hamburger   { display: flex !important; }
              #cpa-user-meta   { display: none !important; }
            }
          `}</style>

          {getFilteredNavItems(userRole).map((item) => {
            const isActive    = activeItem === item.id;
            const isOpen      = openDropdown === item.id;
            const hasChildren = !!item.children;

            return (
              <div
                key={item.id}
                style={{
                  display: "flex", alignItems: "center", gap: 6,
                  padding: "0 13px",
                  fontSize: 12.5, fontWeight: 500,
                  cursor: "pointer", whiteSpace: "nowrap",
                  flexShrink: 0, userSelect: "none",
                  color: isActive || isOpen ? "#21A6E9" : "#475569",
                  borderBottom: isActive ? "2.5px solid #21A6E9" : "2.5px solid transparent",
                  transition: "color .15s, border-color .15s",
                }}
                onMouseEnter={(e) => {
                  if (!isActive) e.currentTarget.style.color = "#21A6E9";
                }}
                onMouseLeave={(e) => {
                  if (!isActive && !isOpen) e.currentTarget.style.color = "#475569";
                }}
                onClick={(e) => {
                  if (hasChildren) {
                    toggleDropdown(item.id, e);
                    setActiveItem(item.id);
                  } else {
                    go(item.route, item.id);
                  }
                }}
              >
                <span style={{ color: "inherit", display: "flex" }}>{item.icon}</span>
                {item.label}
                {hasChildren && (
                  <svg
                    width="11" height="11" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" strokeWidth="2.5"
                    style={{
                      marginLeft: 2, flexShrink: 0,
                      transition: "transform .2s",
                      transform: isOpen ? "rotate(180deg)" : "none",
                    }}
                  >
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                )}
              </div>
            );
          })}
        </div>

        {/* ── DROPDOWN PANEL ── */}
        {openDropdown && (() => {
          const item = getFilteredNavItems(userRole).find((n) => n.id === openDropdown);
          if (!item || !item.children) return null;
          return (
            <div
              ref={dropdownPanelRef}
              style={{
                position: "fixed",
                top:  dropdownPos.top,
                left: dropdownPos.left,
                background: "#ffffff",
                border: "1px solid #e2e8f0",
                borderRadius: 8,
                boxShadow: "0 8px 28px rgba(0,0,0,.13)",
                minWidth: 210,
                padding: "6px 0",
                zIndex: 1201,
              }}
            >
              {item.children.map((child) => (
                <div
                  key={child.route}
                  onClick={() => go(child.route, item.id)}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "#f0f9ff";
                    e.currentTarget.style.color      = "#21A6E9";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "transparent";
                    e.currentTarget.style.color      = "#374151";
                  }}
                  style={{
                    display: "flex", alignItems: "center", gap: 9,
                    padding: "9px 16px", fontSize: 13,
                    cursor: "pointer", color: "#374151",
                    transition: "background .12s",
                  }}
                >
                  <div style={{
                    width: 5, height: 5, borderRadius: "50%",
                    background: "#21A6E9", flexShrink: 0,
                  }} />
                  {child.label}
                </div>
              ))}
            </div>
          );
        })()}

        {/* ── MOBILE NAV ── */}
        {mobileNavOpen && (
          <div style={{
            position: "fixed", top: 96, left: 0, right: 0, bottom: 0,
            background: "#fff", zIndex: 999,
            overflowY: "auto", borderTop: "1px solid #e2e8f0",
          }}>
            {getFilteredNavItems(userRole).map((item) => {
              const hasChildren = !!item.children;
              const expanded    = mobileExpanded === item.id;
              return (
                <div key={item.id}>
                  <div
                    style={{
                      display: "flex", alignItems: "center",
                      justifyContent: "space-between",
                      padding: "13px 20px",
                      borderBottom: "1px solid #f1f5f9",
                      fontSize: 13.5, fontWeight: 500, color: "#334155",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      if (hasChildren) {
                        setMobileExpanded(expanded ? null : item.id);
                      } else {
                        go(item.route, item.id);
                      }
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      <span style={{ color: "#21A6E9", display: "flex" }}>{item.icon}</span>
                      {item.label}
                    </div>
                    {hasChildren && (
                      <svg width="12" height="12" viewBox="0 0 24 24"
                        fill="none" stroke="#94a3b8" strokeWidth="2.5"
                        style={{ transition: "transform .2s", transform: expanded ? "rotate(180deg)" : "none" }}
                      >
                        <polyline points="6 9 12 15 18 9" />
                      </svg>
                    )}
                  </div>

                  {hasChildren && expanded && item.children.map((child) => (
                    <div
                      key={child.route}
                      style={{
                        display: "flex", alignItems: "center", gap: 10,
                        padding: "11px 20px 11px 36px",
                        borderBottom: "1px solid #f8fafc",
                        fontSize: 13, color: "#475569",
                        cursor: "pointer", background: "#f8fafc",
                      }}
                      onClick={() => go(child.route, item.id)}
                      onMouseEnter={(e) => e.currentTarget.style.background = "#e0f2fe"}
                      onMouseLeave={(e) => e.currentTarget.style.background = "#f8fafc"}
                    >
                      <div style={{
                        width: 5, height: 5, borderRadius: "50%",
                        background: "#21A6E9", flexShrink: 0,
                      }} />
                      {child.label}
                    </div>
                  ))}
                </div>
              );
            })}
          </div>
        )}

        <div style={{ height: 96 }} />

        {/* Legacy sidebar — hidden */}
        <div style={{ display: "none" }}>
        {isSidebarOpen ? (
          <aside
            ref={sidebarRef}
            className={`sidebar ${isSidebarOpen ? "open" : ""} font-satoshi`}
            style={{ paddingLeft: "0px" }}
          >
            <ul>
              <img
                src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/logo-navbar-compressed.png"
                onClick={() => { navigate("/admin-dashboard-vendor-customer"); }}
                alt="Dashboard Icon"
                className="company-img"
                style={{ cursor: "pointer" }}
              />
              <li className="li-class" onClick={() => { navigate("/admin-dashboard-vendor-customer"); }}>
                <SpaceDashboardIcon className="icon text-[#21A6E9]" />
                Dashboard
              </li>
            </ul>
          </aside>
        ) : (
          <div>
            {window.innerWidth < 768 && (
              <div className="menu-btn show" onClick={toggleSidebar}>
                <MenuIcon />
              </div>
            )}
          </div>
        )}
        </div>

        <main
          className="content"
          style={{
            paddingLeft: "0px",
            marginLeft: "0px",
            background: "#f4f4f4",
          }}
        >
          <ConfirmationModal
            isOpen={isModalOpen}
            onConfirm={handleConfirmSignOut}
            onCancel={handleCancelSignOut}
          />
        </main>
      </div>
    </div>
  );
};

export default Admin;